
/* ===== STEP3: HOME (KRDS) — 기존 cards 배열/완료판정 재사용 ===== */
(function(){
  var PIA=window.PIA;
  /* [2026-11-03] 선택 검사 4장 아이콘 — 자유대화 주제 아이콘(/images/ill/ic-*.webp)과 같은 화풍(예담 LoRA 3D 클레이)으로
     PC 로컬 생성한 정사각 256px 투명 webp(gen_icopt1103.py). 장식이라 alt 는 빈 문자열.
     예전엔 test.html 의 webp 배경 치환 규칙이 aipia-screens.css 의 .pia-cat__ic{background:… !important} 에 덮여
     배경은 안 그려지고 svg 만 opacity:0 으로 숨겨져, 세 장(강점·학습·진로)이 빈 원으로 보였다(세로 키오스크 실기기). */
  var _IMG=function(n){ return '<img src="/images/ill/ic-opt-'+n+'-256w.webp?v=1103" alt="" width="256" height="256" decoding="async">'; };
  var CATS=[
    {id:'strength',t:'나의 강점',d:'나만의 강점을 알아보세요.',c:'#246BEB',tests:['via','grit'],ic:_IMG('strength')},
    {id:'learning',t:'학습 스타일',d:'나에게 맞는 학습 방법을 찾아보세요.',c:'#246BEB',tests:['learn','mi'],ic:_IMG('learning')},
    {id:'career',t:'진로 탐색',d:'다양한 직업과 정보를 탐색해보세요.',c:'#C2410C',tests:['riasec60','sjt'],ic:_IMG('career')},   /* [2026-11-02 E2-A] 흥미 심화(시범) */
    {id:'mind',t:'마음 건강',d:'지금의 마음 상태를 확인해보세요.',c:'#128700',tests:['rses','cesd','phqa','gad','who5'],ic:_IMG('mind')}
  ];
  var CATS_EN = { strength:{t:'My Strengths',d:'Discover your unique strengths.'}, learning:{t:'Learning Style',d:'Find the learning method that fits you.'}, career:{t:'Career Exploration',d:'Explore various jobs and information.'}, mind:{t:'Emotional Health',d:'Check in on how you\'re feeling right now.'} };
  window._piaCatsEn = CATS_EN;
  /* 2026-09-04: 파싱 시점 1회 실행이라 런타임 언어전환에 반응하지 않던 버그 — 렌더 시점 동적 조회로 대체(아래 cats=CATS.map 참고) */
  var REQ=[
    {id:'chat',   t:'AI와 대화', dur:'약 5분',
     ic:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 9 9 0 0 1-4-.9L3 21l1.9-4.9A8.4 8.4 0 0 1 4 11.5a8.5 8.5 0 0 1 8.5-8.5A8.4 8.4 0 0 1 21 11.5z"/><circle cx="9" cy="11.5" r=".8" fill="currentColor"/><circle cx="12.5" cy="11.5" r=".8" fill="currentColor"/><circle cx="16" cy="11.5" r=".8" fill="currentColor"/></svg>'},
    {id:'big5',   t:'나의 성격', dur:'약 10분',
     ic:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5"/></svg>'},
    {id:'riasec', t:'진로 흥미', dur:'약 7분',
     ic:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="m15.5 8.5-2 5.5-5.5 2 2-5.5z"/></svg>'}
  ];
  var REQ_EN = { chat:{t:'Talk with AI',dur:'About 5 min'}, big5:{t:'My Personality',dur:'About 10 min'}, riasec:{t:'Career Interests',dur:'About 7 min'} };
  /* 2026-09-04: 파싱 시점 1회 실행이라 런타임 언어전환에 반응하지 않던 버그 — 렌더 시점 동적 조회로 대체(아래 steps=REQ.map 참고) */
  window._piaCats=CATS;

  window.piaRenderHomeV2=function(cards,isDone,reqDone){
    var byId={}; cards.forEach(function(c){byId[c.id]=c;});
    window._piaCards=cards; window._piaIsDone=isDone;
    var nextReq=null;
    for(var i=0;i<REQ.length;i++){ if(byId[REQ[i].id] && !isDone(byId[REQ[i].id])){ nextReq=REQ[i].id; break; } }
    /* 2026-09-02: 앞 단계를 마치기 전에는 다음 단계를 잠근다.
       자유대화 → 성격 → 진로흥미 순서가 지켜져야 결과지 게이트에 걸리지 않는다.
       단체 검사(선생님 운영)에서는 순서를 바꿔야 할 때가 있어 잠그지 않는다. */
    var 단체 = false; try { 단체 = !!window._piaGroupMode; } catch(e) {}
    var 자물쇠 = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:1em;height:1em;vertical-align:-.12em"><rect x="4.5" y="10.5" width="15" height="10" rx="2"/><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"/></svg>';
    var _pl3 = (window.aipiaCurrentLang === 'en');
    var steps=REQ.map(function(s,i){
      var dn=byId[s.id]?isDone(byId[s.id]):false, nx=(s.id===nextReq);
      var 잠김 = !단체 && !dn && !nx;
      var _st = (_pl3 && REQ_EN[s.id]) ? REQ_EN[s.id] : s;
      /* 완료·진행 모두 파랑. 초록(KRDS success)은 검사 완료 표시에 쓰지 않는다. */
      var nb=(dn||nx)?'#246BEB':'#E0E4EA', nf=(dn||nx)?'#fff':'#5C656E';
      var ib=(dn||nx)?'#EAF1FE':'#F4F5F6', if_=(dn||nx)?'#246BEB':'#9AA5B4';
      return '<div class="pia-step'+(잠김?' pia-step--lock':'')+'">'
        +'<span class="pia-step__n" style="background:'+nb+';color:'+nf+'">'+(i+1)+'</span>'
        +'<button type="button" class="pia-step__ic" style="background:'+ib+';color:'+if_+'" data-act=\'[["piaGoTest","'+s.id+'",'+(잠김?'1':'0')+']]\' aria-label="'+_st.t+(잠김?(_pl3?' \u2014 After previous step':' — 이전 단계 완료 후'):(_pl3?' Start':' 시작'))+'">'+s.ic+'</button>'
        +'<span class="pia-step__t">'+_st.t+'</span>'
        /* 잠금 안내 자리는 세 단계에 모두 둔다(잠기지 않은 단계는 빈 칸).
           한쪽에만 두면 그 단계만 아래로 밀려 시간 칩 높이가 어긋난다. */
        +'<span class="pia-step__lock">'+(잠김 ? (자물쇠+(_pl3?' After previous step':' 이전 단계 완료 후')) : '')+'</span>'
        +'<span class="pia-step__d pia-chip">'+_st.dur+'</span></div>'
        +(i<REQ.length-1?'<span class="pia-step__ar" aria-hidden="true">→</span>':'');
    }).join('');
    var _pl2 = (window.aipiaCurrentLang === 'en');
    var cats=CATS.map(function(k){
      var n=k.tests.filter(function(t){return byId[t]&&isDone(byId[t]);}).length;
      var _ck=(_pl2&&CATS_EN[k.id])?CATS_EN[k.id]:k;
      return '<button type="button" class="pia-cat" data-act="piaOpenCategory" data-arg="'+k.id+'">'
        +'<span class="pia-cat__ic" style="color:'+k.c+'" aria-hidden="true">'+k.ic+'</span>'
        +'<span class="pia-cat__tx"><span class="pia-cat__t">'+_ck.t
        +(n>0?' <span class="pia-badge pia-badge--done">'+n+'/'+k.tests.length+'</span>':'')+'</span>'
        +'<span class="pia-cat__d">'+_ck.d+'</span></span>'
        +'<span class="pia-cat__ar" aria-hidden="true">›</span></button>';
    }).join('');
    var allDone = !nextReq;
    /* 접힌 줄에 '2/10 완료'처럼 보여주려면 선택 검사 전체·완료 수가 필요하다 */
    var optTotal = 0, optDone = 0;
    CATS.forEach(function(k){
      k.tests.forEach(function(t){
        optTotal++;
        if (byId[t] && isDone(byId[t])) optDone++;
      });
    });
    var _pl2 = (window.aipiaCurrentLang === 'en');
    var startLabel = _pl2
      ? (nextReq ? (reqDone>0?'Continue Assessment':'Start Assessment') : 'Retake Assessment')
      : (nextReq ? (reqDone>0?'이어서 검사하기':'검사 시작하기') : '검사 다시 하기');
    return '<div class="pia">'
      +'<section class="pia-sec pia-hero pia-hero--v2" data-ydp-keep><div class="pia-hero__row">'
      +'<div class="pia-hero__tx"><h1 class="pia-display">'+(_pl2?'Discover Yourself<br><span style="color:var(--pia-primary)">AI Career &amp; Personality Assessment</span>':'나를 알아보는<br><span style="color:var(--pia-primary)">AI 인·적성 검사</span>')+'</h1>'
      +'<p class="pia-bodyL pia-muted" style="margin:var(--pia-s3) 0">'+(_pl2?'Combine AI conversation, personality, and career interests<br>to find the path that fits you.':'AI 대화, 성격, 진로 흥미를 종합해<br>나에게 맞는 진로를 찾아보세요.')+'</p>'
      +'<p class="pia-hero__time">'+PIA.icon('clock')+' '+(_pl2?'About 20 min':'약 20분')+'</p></div>'
      +'<div class="pia-hero__bot">'+PIA.botImg('hero','예담 톡 캐릭터')+'</div>'
      +'</div>'
      /* 단체 검사는 홈 아래쪽에 따로 떨어져 있어 선생님이 찾기 어려웠다.
         시작 버튼 바로 밑으로 올리고, 학생용 1차 버튼과 구분되게 외곽선으로 둔다. */
      +'<div style="margin-bottom:var(--pia-s3)">'
      + PIA.btn(startLabel,'piaStartFlow()','primary',{cta:1,arrow:1})
      +'<div style="height:var(--pia-s2)"></div>'
      /* 앞 학생의 프로필·동의·답안을 모두 지우고 처음부터 다시 시작한다.
         상단 프로필 바를 없앤 뒤 유일한 초기화 진입점이라 홈에 항상 둔다.
         (단체 검사 시작이 있던 자리 — startGroupTest() 함수는 그대로 남아 있다) */
      +'<button type="button" class="pia-group-btn pia-group-btn--reset" data-act=\'[["newStudent",{"바로시작":1}]]\'>'
        +'<span class="pia-group-btn__ic" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg></span>'
        +'<span class="pia-group-btn__t">'+(_pl2?'Start New Assessment':'검사 새로 시작하기')+'</span>'
        +'<span class="pia-group-btn__ar" aria-hidden="true">›</span>'
      +'</button>'
      +'</div>'
      /* 가로 키오스크(낮은 화면)에서만 보이는 쪽 넘김 버튼 — 첫 화면에 시작 버튼까지만 담고,
         검사 진행 현황·선택 검사는 다음 쪽으로 넘긴다(스크롤 대신 쪽 넘김, CSS 로 표시 여부 결정). */
      +'<button type="button" class="pia-pager pia-pager--down" data-act="piaPage" data-args="[1]">'+(_pl2?'Progress &amp; more assessments ▾':'검사 진행 현황 · 선택 검사 보기 ▾')+'</button>'
      +'</section>'
      +'<button type="button" class="pia-pager pia-pager--up pia-page2" data-act="piaPage" data-args="[-1]">'+(_pl2?'▴ Back to start':'▴ 처음 화면으로')+'</button>'
      +'<section class="pia-sec pia-sec--qa"><h2 class="pia-h2" style="margin-bottom:var(--pia-s4)">'+(_pl2?'Required Assessments':'필수 검사')+' <span style="color:var(--pia-primary)">'+reqDone+'</span>/3</h2>'
      +'<div class="pia-steps">'+steps+'</div>'
      /* 항상 보인다. reqDone(완료 수)으로 감추면 검사를 푸는 도중 —
         정작 되돌리고 싶은 순간 — 에 버튼이 사라진다. */
      + '<button type="button" class="pia-restart" data-act="piaRestartRequired">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>'
        + '<span>'+(_pl2?'Retake Required Assessments':'필수 검사 다시하기')+'</span></button>'
      +'</section>'
      /* 필수 3종을 마치기 전에는 선택 검사를 한 줄로 접어 첫 화면을 비운다.
         다 마치면 펼쳐서 바로 눈에 띄게 한다 — 선택 검사를 많이 할수록
         분석 정확도가 올라가는 구조라, 접어만 두면 응시율이 떨어진다. (2026-09-02) */
      +'<section class="pia-sec pia-sec--qa">'
      + (allDone
          ? '<h2 class="pia-h2" style="margin-bottom:var(--pia-s3)">'+(_pl2?'Optional Assessments':'선택 검사')+'</h2>'
            +'<div class="pia-cats">'+cats+'</div>'
          : '<h2 class="pia-h2" style="margin-bottom:var(--pia-s3)">'+(_pl2?'Optional Assessments':'선택 검사')+'</h2>'
            +'<button type="button" class="pia-optfold" data-act="piaToggleOptional" aria-expanded="false" aria-controls="pia-optional-body">'
              +'<span class="pia-optfold__tx"><span class="pia-optfold__t">'+(_pl2?'More Optional Assessments':'선택 검사 더 알아보기')
              + (optDone>0 ? ' <span class="pia-badge pia-badge--done">'+optDone+'/'+optTotal+'</span>' : '')
              +'</span>'
              +'<span class="pia-optfold__d">'+(_pl2?'Strengths \u00b7 Learning Style \u00b7 Career \u00b7 Emotional Health':'강점 · 학습 스타일 · 진로 탐색 · 마음 건강')+'</span></span>'
              +'<span class="pia-optfold__ar" aria-hidden="true">›</span></button>'
            +'<div id="pia-optional-body" class="pia-cats" hidden style="margin-top:var(--pia-s3)">'+cats+'</div>')
      +'</section>'
      +'<div class="pia-foot"><button type="button" data-act="piaShowAllTests">'+(_pl2?'All Assessments':'전체 검사 목록')+'</button>'
      +'<span aria-hidden="true">|</span><button type="button" data-act="showView" data-arg="help">'+(_pl2?'Help':'이용안내')+'</button></div>'
      +'</div>';
  };
  window.piaToggleOptional=function(){
    try{
      var b=document.getElementById('pia-optional-body');
      var t=document.querySelector('.pia-optfold');
      if(!b||!t) return;
      var 열림 = !b.hasAttribute('hidden');
      if(열림){ b.setAttribute('hidden',''); } else { b.removeAttribute('hidden'); }
      t.setAttribute('aria-expanded', 열림?'false':'true');
      t.classList.toggle('pia-optfold--open', !열림);
    }catch(e){ console.error('선택 검사 펼치기 실패', e); }
  };
  window.piaGoTest=function(id, 잠김){
    /* 잠긴 단계라도 완전히 막지는 않는다. 재검사나 교실 사정으로 순서를 바꿔야
       할 때가 있어, 권고만 하고 본인이 확인하면 들어가게 한다. (2026-09-02) */
    if(잠김){
      if(!confirm('앞 단계를 먼저 마치는 것을 권합니다.\n그래도 이 검사를 진행할까요?')) return;
    }
    if(!state.profile){ window._piaPendingTest=id; showView('setup'); return; }
    showView(id);
  };
  window.piaStartFlow=function(){
    try{
      if(sessionStorage.getItem('pia_v3_consent')!=='1'){ showView('consent'); return; }
      if(!state.profile){ showView('setup'); return; }
      var b={}; (window._piaCards||[]).forEach(function(c){b[c.id]=c;});
      var nx=null; for(var i=0;i<REQ.length;i++){ if(b[REQ[i].id]&&!window._piaIsDone(b[REQ[i].id])){nx=REQ[i].id;break;} }
      showView(nx||'result');
    }catch(e){ showView('setup'); }
  };
})();

/* 쪽 넘김(가로 키오스크): dir=1 다음 쪽(진행 현황), -1 처음 화면. 스크롤 대신 한 번에 한 쪽씩 옮긴다. */
window.piaPage=function(dir){
  try{
    if(dir>0){ var s=document.querySelector('.pia-page2'); if(s){
      var go=function(smooth){ var y=Math.round(s.getBoundingClientRect().top+window.pageYOffset-8); window.scrollTo(smooth?{top:y,behavior:'smooth'}:{top:y}); };
      go(true);
      /* 부드러운 이동이 도중에 끊겨도(화면 전환·글꼴 늦은 적용) 제자리에 맞춘다 */
      setTimeout(function(){ if(Math.abs(s.getBoundingClientRect().top-8)>4) go(false); }, 700);
      return; } }
    window.scrollTo({top:0,behavior:'smooth'});
  }catch(e){ window.scrollTo(0, dir>0 ? window.innerHeight : 0); }
};

/* 긴 화면 쪽 넘김(가로 키오스크): 결과지·도움받기처럼 한 화면에 담을 수 없는 긴 화면은
   오른쪽 가장자리의 ▲▼ 버튼으로 한 쪽씩 넘긴다(국내 키오스크 UI 가이드: 스크롤보다 쪽 넘김).
   손가락으로 미는 스크롤은 그대로 된다. 표시 여부는 CSS(가로 + kiosk-on)가 정하고,
   여기서는 문서가 화면의 1.15배보다 길 때만 켠다. 시작 화면은 자체 쪽 넘김 버튼이 있어 뺀다. */
(function(){
  if(window.__piaFlip) return; window.__piaFlip=true;
  var box,up,dn,lab;
  function H(){ return window.innerHeight||document.documentElement.clientHeight; }
  function full(){ return Math.max(document.documentElement.scrollHeight, document.body?document.body.scrollHeight:0); }
  function y(){ return window.pageYOffset||document.documentElement.scrollTop||(document.body?document.body.scrollTop:0)||0; }
  function step(){ return Math.max(200, Math.round(H()*0.86)); }
  function build(){
    if(box||!document.body) return;
    box=document.createElement('div'); box.className='pia-flip'; box.setAttribute('role','group'); box.setAttribute('aria-label','쪽 넘김');
    up=document.createElement('button'); up.type='button'; up.className='pia-flip__b'; up.setAttribute('aria-label','이전 쪽'); up.textContent='▲';
    lab=document.createElement('span'); lab.className='pia-flip__n'; lab.setAttribute('aria-live','polite');
    dn=document.createElement('button'); dn.type='button'; dn.className='pia-flip__b'; dn.setAttribute('aria-label','다음 쪽'); dn.textContent='▼';
    up.addEventListener('click',function(){ window.scrollTo({top:Math.max(0,y()-step()),behavior:'smooth'}); });
    dn.addEventListener('click',function(){ window.scrollTo({top:Math.min(full()-H(),y()+step()),behavior:'smooth'}); });
    box.appendChild(up); box.appendChild(lab); box.appendChild(dn); document.body.appendChild(box);
  }
  function sync(){
    try{
      build(); if(!box) return;
      var hero=document.querySelector('.pia-hero--v2'); var heroOn=!!(hero&&hero.offsetParent);
      var modal=document.querySelector('.pia-modal'); var modalOn=!!(modal&&modal.offsetParent);
      var long=full()>H()*1.15;
      var on=long&&!heroOn&&!modalOn;
      box.classList.toggle('on',on);
      if(!on) return;
      var total=Math.max(1,Math.ceil((full()-H())/step())+1);
      var cur=Math.min(total,Math.round(y()/step())+1);
      if(y()+H()>=full()-4) cur=total;
      lab.textContent=cur+' / '+total;
      up.disabled=(y()<=2); dn.disabled=(y()+H()>=full()-4);
    }catch(e){}
  }
  window.addEventListener('scroll',sync,{passive:true});
  window.addEventListener('resize',sync);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',sync); else sync();
  setInterval(sync,1200);
})();
